import { Currency } from "../Currency.js";
import { Locale } from "../Locale.js";

export const localeToCurrencyMap: Record<Locale, Currency> = {
	[Locale.cs]: Currency.CZK,
	[Locale.de]: Currency.EUR,
	[Locale.en]: Currency.EUR,
	[Locale.hu]: Currency.EUR,
	[Locale.pl]: Currency.EUR,
};
